// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { parsePhoneNumberWithError } from 'libphonenumber-js';
import * as yup from 'yup';

/**
 * Phone Number validator for yup based on libphonenumber-js
 * Use the [E.164](https://en.wikipedia.org/wiki/E.164) standard
 */
export const phoneNumber = ({ required = false } = {}) => {
  const validator = yup
    .string()
    .test(
      'test-phone-number',
      'Please enter a valid phone number',
      function (value?: string) {
        if (!value) return true;

        try {
          const phoneNumber = parsePhoneNumberWithError(value);

          if (!phoneNumber) return false;

          if (phoneNumber.format('E.164') !== value) return false;

          return phoneNumber.isValid();
        } catch (error) {
          return false;
        }
      }
    );

  if (required) {
    return validator.required('The phone number is required');
  }

  return validator;
};
